import React from 'react';
import './ProjectPageLayout.css';
import ImageGallery from './ImageGallery';

const ProjectPageLayout = ({
  title,
  imageUrl,
  imageAlt,
  galleryImages,
  history,
  aimsAndObjectives,
  committeeMembers,
  additionalContent,
  contactInfo,
  donateLink = "/donate"
}) => {
  return (
    <div className="project-page-layout">
      <header className="project-header">
        <h1>{title}</h1>
      </header>

      <div className="project-content">
        <div className="project-main-content">
          {history && (
            <div className="project-section">
              <h2>History</h2>
              {typeof history === 'string' ? <p>{history}</p> : history}
            </div>
          )}

          {aimsAndObjectives && (
            <div className="project-section">
              <h2>Aim and Objectives</h2>
              {aimsAndObjectives}
            </div>
          )}
        </div>
        
        {imageUrl && (
          <div className="project-sidebar">
            <img src={imageUrl} alt={imageAlt || title} className="project-image" />
          </div>
        )}
      </div>

      {galleryImages && <ImageGallery images={galleryImages} />}

      {committeeMembers && (
        <div className="project-section committee-section">
          <h2>Committee Members</h2>
          {committeeMembers}
        </div>
      )}

      {additionalContent && (
        <div className="project-section additional-content-section">
          {additionalContent}
        </div>
      )}

      {contactInfo && (
        <div className="project-section contact-section">
          <h2>Contact Information</h2>
          {contactInfo}
        </div>
      )}
    </div>
  );
};

export default ProjectPageLayout; 